import { getPropertyOf, LoggerUtil } from "@cs/core";
import { ErrorMessage } from "@cs/performance-manager/shared";

export interface IAccountInfo {
	isLDAP: boolean;
	userName: string;
}

export interface LoginModel {

	/**
	 * Whether this provider is the currently-selected auth method. Returned by
	 * the server (one entry flagged `active: true`) and kept in sync on the
	 * client when the user switches methods. Source of truth for resolving the
	 * provider's `onLoginClickRedirectToUrl` on login.
	 */
	active?: boolean;
	/** Whether to show the request-access prompt */
	requestNewAccountAvailable?: boolean
	/**
	 * Whether this auth method requires a login-name / username to be entered.
	 * Matches the server field name `requiresLoginname` returned by GET /users/login.
	 */
	requiresLoginname?: boolean;
	/**
	 * @deprecated The server returns `requiresLoginname`. This alias is kept for
	 * backward compatibility only and should not be used in new code.
	 */
	requiresUsername?: string;
	/**
	 * Gets or sets the URL to redirect to after login.
	 */
	onLoginClickRedirectToUrl?: any;
	/**
	 * Server-provided pre-fill for the login name (the remembered username for
	 * this auth method). When present, it seeds the username field.
	 */
	value?: string;
	/**
	 * Gets or sets the username.
	 */
	username: string;
	/**
	 *
	 */
	readonly requiresPassword?: boolean;
	/**
	 *
	 */
	readonly forgotPasswordAvailable?: boolean;
	/**
	 * Gets or sets the password.
	 */
	password?: string;
	/**
	 *
	 */
	readonly requiresCallBackUrl?: boolean;
	/**
	 * A callback url, for providers that require a external login.
	 */
	callBackUrl?: string;
	/**
	 * Gets or sets the method for authenticating
	 */
	method?: string;
	/**
	 * Indicates if the Google Captcha should be shown
	 */
	readonly requiresGoogleCaptcha?: boolean;
	/**
	 *
	 */
	readonly googleCaptchaChallenge?: string;
	/**
	 *
	 */
	googleCaptchaResponse: string;
}

export class AccountInfo implements IAccountInfo {
	isLDAP: boolean;
	userName: string;

	constructor(init: Partial<AccountInfo>) {
		try {
			this.isLDAP = getPropertyOf(init, "isLDAP", false);
			this.userName = getPropertyOf(init, "userName");
		} catch (e) {
			LoggerUtil.error(
				ErrorMessage.MAPPING_BUSINESS_MODEL_TO_APPLICATION_MODEL_FAILED(
					AccountInfo,
					e,
				),
			);
		}
	}
}
